<template>
    <div>
        <Dialog :visible.sync="exibirModal" header="Baixar Comprovantes" :modal="true" :style="{width: '400px'}">
            <div class="p-fluid p-formgrid p-grid">                
                <div class="p-field p-col-12 p-md-6">
                    <label>Data Início</label>	
                    <div class="p-inputgroup">                        
                        <Calendar v-model="dataInicio" dateFormat="dd/mm/yy" :manualInput="false" 
                        :showIcon="true" :locale="localeCalendarBR" appendTo="body"/>                   
                    </div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Data Final</label>	
                    <div class="p-inputgroup">
                        <Calendar v-model="dataFinal" dateFormat="dd/mm/yy" :manualInput="false" 
                        :showIcon="true" :locale="localeCalendarBR" appendTo="body"/>                   
                    </div>
                </div>	
            </div>
            <Message severity="info" :closable="false"><span style="font-size: 16px;">Período máximo de 10 (dez) dias!</span></Message> 
            <template #footer>       
                <Button label="Cancelar" icon="pi pi-times" @click="exibirModal=false" />
                <Button label="Enviar" icon="pi pi-check" @click="baixar" />
            </template>
        </Dialog>
    </div>
</template>

<script>
import PontoService from '@/service/PontoService';
import { mapGetters, mapActions } from 'vuex';
import { exibirMensagem, localeCalendarBR } from '@/global';

export default {   
    pontoService: null, 
    data() {
        return {
            localeCalendarBR: localeCalendarBR,            
            exibirModal: false,
            dataInicio: new Date(),
            dataFinal: new Date()
        }
    },
    methods: {
        ...mapGetters('sessao', ['getUsuario']),
        ...mapActions('sessao', ['limparSessao']),  
        /**
         * 
         */     
        exibir() {
            this.exibirModal = true;
        },
        /**
         * 
         */
        baixar() {
            let usuario = this.getUsuario();
            let requisicao = {
                id: usuario.id,
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                tipoDispositivo: 'Web'
            };
            this.pontoService.downloadMarcacaoPdf(requisicao)
            .then(resp => {              
                this.exibirModal = false;
                let blob = new Blob([resp.data]);     
                let nomeArquivo = 'comprovantes_'+(Date.now())+'.pdf';
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, nomeArquivo);
                } else {
                    var aLink = document.createElement('a');
                    document.body.appendChild(aLink);
                    var url = window.URL.createObjectURL(blob);
                    aLink.setAttribute('id', Date.now());
                    aLink.setAttribute('href', url);
                    aLink.setAttribute("download", nomeArquivo);
                    aLink.click();
                    setTimeout(function(){window.URL.revokeObjectURL(url)}, 200);
                    aLink.remove();
                }                
            })
            .catch(erro => {
                if(erro.response.status == 401) {
                    this.logout();
                } else {                    
                    if(erro.response.headers['ik-response']) {
                        erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                    }
                    exibirMensagem(this, erro)
                }  
            });             
        },        
        /**
         * 
         */
        formatarData(data) {
            if(!data) {
                return null;
            }
            let strData = null;
            if(data instanceof Date) {
                let dt = data;
                let mes = dt.getMonth();
                let dia = dt.getDate();
                strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
            } else {
                let partes = data.split('/');
                strData = partes[2] + '-' + partes[1] + '-' + partes[0];
            }
            return strData;
        },
        /**
         * 
         */
        logout() {
          this.limparSessao();			
          this.$router.push('/login?exp=sessao_expirada');
        } 
    },
    created() {
        this.pontoService = new PontoService();
    }
}

</script>